import React from 'react'
import styled from 'styled-components'
import {Button} from 'grommet/components/Button'

const Container = styled(Button)`
  display: flex;
  /* width: 250px;*/
  width: 100%;
  height: 46px;
  align-items: center;
  justify-content: space-between;
  background-color: #f3f5fb;
  border-radius: 6px;
  color: ${props => (props.selected ? '#3395fe' : 'default')};
  box-shadow: ${props =>
    props.selected ? '0 1px 6px 0 rgba(51, 149, 254, 0.38)' : 'none'};
`

const Label = styled.div`
  padding: 12px 10px;
  font-size: 16px;
  font-weight: 600;
`

const Time = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${props => (props.selected ? '#3395fe' : '#a4a9b7')};
  text-align: right;
  padding-right: 10px;
`

class TimeItem extends React.Component {
  onClick = () => {
    this.props.onSelect(this.props.index)
  }

  render() {
    const {startTime, endTime, label, selected} = this.props

    return (
      <Container onClick={this.onClick} selected={selected}>
        <Label>{label}</Label>
        <Time selected={selected}>{`${startTime} - ${endTime}`}</Time>
      </Container>
    )
  }
}

TimeItem.defaultProps = {
  onSelect: () => {}
}
export default TimeItem
